import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setPage } from "../../../slices/adminPageSlice";

import { Dropdown as CustomDropdown } from "pepsico-ds";
import "../admin-common.css";

const baseOptions = [
  "Subject matter experts",
  "Send invitation: external partners",
  "Send invitation: internal users",
  "Access: invitation history",
  "In the spotlight",
  "Subjects",
  "Landing page hero",
  "Access: pending approvals",
  "Access",
  "Special projects",
  "List of values",
  "Apps",
];
export default function DropDown({ datatestid }) {
  const dispatch = useDispatch();
  const [dropdownOptions, setDropdownOptions] = useState([]);

  useEffect(() => {
    let extendedOptions = [...baseOptions];
    if (process.env.REACT_APP_FORUM_FEATURE === "true") {
      extendedOptions.push("Forum builder");
    }
    if (process.env.REACT_APP_PAGE_BUILDER === "true") {
      extendedOptions.push("Page builder");
    }
    const sortedAndFormatted = extendedOptions
      .sort((a, b) => a.localeCompare(b))
      .map((item, idx) => ({ id: idx + 1, displayText: item }));

    setDropdownOptions(sortedAndFormatted);
  }, []);

  const { selectedPage } = useSelector((store) => store.adminpage);
  const HandleChange = (event, newValue) => {
    newValue && dispatch(setPage(newValue));
  };

  const isDarkTheme = useSelector((state) => state.theme);

  return (
    <CustomDropdown
      label="Administration type"
      childList={dropdownOptions}
      isDark={isDarkTheme}
      setSelectedValue={(e) => HandleChange(e, e && e[0]?.displayText)}
      className="admin-dropdown"
      selectedValue={
        dropdownOptions.filter((item) => item.displayText === selectedPage) ||
        []
      }
      isClearable={false}
      placeholder="Select One"
      data-testid="admin-dropdown"
      value={selectedPage}
    />
  );
}
